import type { MessageReceived } from '@api/types';
import type { TranslationFunctions } from '@i18n/i18n-types';

export function getMessageText(LL: TranslationFunctions, message: MessageReceived, currentUserId: string) {
    if (message.type === 'gift') {
        return LL.message.sidebar.gift();
    }
    if (message.type === 'giftRequest') {
        return LL.message.sidebar.giftRequested();
    }
    const originalText = message.data?.text.originalText;
    const translatedText = message.data?.text.translatedText;
    if (originalText && message.userId === currentUserId) {
        return originalText;
    } else if (translatedText) {
        return translatedText;
    } else {
        return originalText;
    }
}
